import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FiltersStateType, Keys } from "src/pages/DashboardPage/acadia/type";

export const useGetBreadCrumbs = (filters: FiltersStateType) => {
  function buildBreadcrumbsUsingMap(input: FiltersStateType): string[] {
    const keysOrder: Keys[] = ["collections", "departments", "sectors", "processes", "types"];
    const result: string[] = [];
    const baseFilters = _.pick(input, keysOrder);

    keysOrder.forEach((key) => {
      if (baseFilters[key].length > 0) {
        input[key].forEach((v) => result.push(v.title));
      }
    });

    const restFilters = _.values(_.omit(input, [...keysOrder, "dateForRevision"]));

    restFilters.forEach((filters) => {
      if (filters.length > 0) {
        filters.forEach((v) => result.push(v.title));
      }
    });

    if (!_.isEmpty(_.values(input.dateForRevision.date))) {
      const { start, end } = input.dateForRevision.date;
      const startText = start ? "от " + moment(start).locale("ru").format("DD.MM.YYYY") : null;
      const endText = end ? "до " + moment(end).locale("ru").format("DD.MM.YYYY") : null;

      const dateText = (start === end ? [startText, null] : [startText, endText]).join(" ").trim();

      if (input.dateForRevision.required) {
        // const startRequiredText = "от " + moment(new Date()).locale("ru").format("DD.MM.YYYY");
        // const endRequiredText = "до " + moment(new Date()).add(30, "day").locale("ru").format("DD.MM.YYYY");
        // result.push([startRequiredText, endRequiredText].join(" "));
        result.push("Требуется пересмотр");
      }

      if (dateText !== "") {
        result.push(dateText);
      }
    }

    return result;
  }
  const text = useMemo(() => buildBreadcrumbsUsingMap(filters), [JSON.stringify(filters)]);

  return useMemo(() => ({ breadcrumbs: <FilterDisplay filters={text} />, length: text.length }), [text]);
};

export default useGetBreadCrumbs;

// export function MyDocumentsBreadCrumbs({ active }: { active: "filter" | "folder" }) {
//   const breads: string[] = useGetBreadCrumbs(active);

//   return (
//     <>
//       <div className="flex items-center w-full text-base font-medium">
//         {breads.length > 0 ? breads.join(", ") : active === "folder" ? <div>Фильтры не выбраны</div> : <div>Все</div>}
//       </div>
//     </>
//   );
// }

export const FilterDisplay = ({ filters }: { filters: string[] }) => {
  const [displayedFilters, setDisplayedFilters] = useState<string[]>([]);
  const [remainingCount, setRemainingCount] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const measureText = useCallback((text: string, font: string) => {
    if (!canvasRef.current) {
      canvasRef.current = document.createElement("canvas");
    }
    const context = canvasRef.current.getContext("2d");
    context!.font = font;
    return context!.measureText(text).width;
  }, []);

  const updateDisplay = useCallback(() => {
    if (containerRef.current) {
      const font = window.getComputedStyle(containerRef.current).font;
      const containerWidth = containerRef.current.clientWidth * 2 - Math.ceil(measureText("... ещё 999", font)) - 100;

      let currentWidth = 0;
      let tempDisplayed: string[] = [];
      let tempRemainingCount = 0;

      filters.forEach((filter, index) => {
        const textWidth = Math.ceil(measureText(filter, font));

        if (index > 1) {
          currentWidth += Math.ceil(measureText(", ", font));
        }

        if (currentWidth + textWidth > containerWidth) {
          tempRemainingCount++;
        } else {
          tempDisplayed.push(filter);
          currentWidth += textWidth;
        }
      });

      setDisplayedFilters((prevDisplayed) => {
        if (!_.isEqual(prevDisplayed, tempDisplayed)) {
          return tempDisplayed;
        }
        return prevDisplayed;
      });
      setRemainingCount(tempRemainingCount);
    }
  }, [filters, measureText]);

  useEffect(() => {
    updateDisplay();
    const resizeObserver = new ResizeObserver(updateDisplay);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current, { box: "border-box" });
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [updateDisplay]);

  return (
    <div ref={containerRef} id="filter-container" className="w-full font-medium">
      <span>
        {displayedFilters.join(", ")}
        <span>{remainingCount > 0 && ` ...еще ${remainingCount}`}</span>
      </span>
    </div>
  );
};
